$(document).ready(function () {
    var init_class;
    if (abcsetup.item != undefined) {
        init_class = abcsetup.item.role.class;
    }
    else {
        init_class = '';
    }

    $.each(['case','dozens','inner','item','display'], function(uom_idx,uom) {
        $("#"+uom+"_ndc10_format").change(function() {
            var ndc10_format = $(this).val();
            var ndc10 = $("#"+uom+"_ndc_10");
            var ndc11 = $("#"+uom+"_ndc");

            if (ndc10_format && ndc10_format.length) {
                switch (ndc10_format) {
                    case "4-4-2":
                        ndc10.mask("9999-9999-99", {reverse: true});
                        break;
                    case "5-3-2":
                        ndc10.mask("99999-999-99", {reverse: true});
                        break;
                    case "5-4-1":
                        ndc10.mask("99999-9999-9", {reverse: true});
                        break;
                }
            }
            else {
                ndc10.val("").closest("tr").hide();
            }

            //if (ndc11.val().length) {
            //    ndc11.trigger("change");
            //}
        }).trigger("change");

        $("#"+uom+"_ndc_10").change(function() {
            var ndc10 = $(this).val();
            var ndc10_format = $("#"+uom+"_ndc10_format").val();
            var ndc11 = $("#"+uom+"_ndc");

            if (ndc10.length) {
                switch (ndc10_format) {
                    case "4-4-2":
                        var str = "0" + ndc10.replace(/\-/g,"");
                        ndc11.val(str);
                        break;
                    case "5-3-2":
                        var str = ndc10.substr(0, 5) + "0" + ndc10.substr(6, 3) + ndc10.substr(10, 2);
                        ndc11.val(str);
                        break;
                    case "5-4-1":
                        var str = ndc10.substr(0, 5) + ndc10.substr(6, 4)  + "0" + ndc10.substr(11, 1);
                        ndc11.val(str);
                        break;
                }
            }
        }).trigger("change");
    });

    /*
    Required logic for identifiers
    */
   var init_has_one = {
       item_article_identifier: false,
       inner_article_identifier: false,
       case_article_identifier: false,
       dozens_article_identifier: false,
       display_article_identifier: false
    };
   var init = true;
    $(".item_article_identifier, .inner_article_identifier, .case_article_identifier, .dozens_article_identifier .display_article_identifier").change(function() {
        var this_css_class;
        var css_classes = ["item_article_identifier","inner_article_identifier","case_article_identifier","dozens_article_identifier","display_article_identifier"];
        for (var idx in css_classes) {
            if ($(this).hasClass(css_classes[idx])) {
                this_css_class = css_classes[idx];
                break;
            }
        }
        // console.log(this_css_class+":"+$(this).attr("name")+":"+$(this).val());
        var at_least_one = false;
        $("."+this_css_class).each(function() {
            if ($(this).val()) {
                at_least_one = true;
                if (init){
                    init = false;
                    init_has_one[this_css_class] = true;
                }
                return;
            }
        });
        // console.log(this_css_class+":"+at_least_one);
        // console.log(this_css_class+":"+init_has_one[this_css_class]);
        $("."+this_css_class).each(function() {
            if (!at_least_one && init_has_one[this_css_class]) {
                $(this).attr('required', true);
                $(this).closest("div.form-group").addClass("required");
            }
            else if ($(this).val()) {
                $(this).attr('required', true);
                $(this).closest("div.form-group").addClass("required");
            }
            else {
                $(this).attr('required', false).removeClass("invalid");
                $(this).closest("div.form-group").removeAttr("requiredIf").removeClass("required");
            }
        });
    }).trigger("change");

    $("#pr_distribution_only").change(function() {
        if ($("#pr_distribution_only").val() == 'Y' && !['promo_image_reviewer'].includes(abcsetup.userRole.class)) {
            abcsetup.alerts.show("Warning: Puerto Rico Distribution Only","By selecting Yes, you are indicating that this item will <font size='4' style='bold' color='#F03200'>ONLY</font> be distributed in Puerto Rico, and <font size='4' style='bold' color='#F03200'>NOT</font> in the mainland USA.  If you want the item distributed in both Puerto Rico and the mainland USA, you must select No in this field.");
        }

        //toggle_submit_item_button();
     }).trigger("change", {initialRun: true});;

    $("#eligible_sale_pr").change(function() {
        var eligible_sale_pr = $(this).val();
        if (eligible_sale_pr != abcsetup.item.eligible_sale_pr){
            if (eligible_sale_pr == "Y") {
                $('button#pr_registration_doc').addClass('required btn-danger').show();
            }
            else if (eligible_sale_pr == "in_process") {
                if (abcsetup.userRole.class == 'vendor' || abcsetup.userRole.class == 'rx_vendor') {
                    abcsetup.alerts.show("Warning: Puerto Rico Distribution: In Process", "By selecting 'In Process', you are indicating that your company has initiated registering this item for sale in Puerto Rico, but have not yet received the registration documentation from the Puerto Rico Department of Health. <br><br><font style='bold' color='#F03200'>YOU WILL NEED TO SUBMIT THE REGISTRATION DOCUMENT AS SOON AS YOU OBTAIN IT.</font>");
                }
                $('button#pr_registration_doc').removeClass('required btn-danger').show();
            }
            else {
                $('button#pr_registration_doc').removeClass('required btn-danger').hide();
            }
        } else {
            $('button#pr_registration_doc').removeClass('required btn-danger').hide();
        }
    }).trigger("change");

    $(function() {
        if ($("#eligible_sale_pr").length > 0 && $("#eligible_sale_pr").val() != "") {
            if (abcsetup.item.eligible_sale_pr != $("#eligible_sale_pr").val()) {
                $("#eligible_sale_pr").trigger("change");
            }
        }
        else {
            $('button#pr_registration_doc').removeClass('required btn-danger');
        }
    });

    var sds_button_iata = false;
    var sds_button_cfr = false;

    $("#product_regulated_cfr").change(function() {
        $("#sds_waiver").attr('required',false).closest("div.form-group").removeAttr("requiredIf").removeClass("required");
        $(this).addClass('changed');
        if ($(this).val() == "N") {
            sds_button_cfr = false;
            if (sds_button_iata){
                $("#sds_waiver").attr('required',true).closest("div.form-group").addClass("required");
                $("#sds_waiver").addClass("enforce_required").trigger('change');
                var sds_waiver = $("#sds_waiver").val();
                if (sds_waiver == "N") {
                    $("button#sds_waiver").addClass("required btn-danger").show();
                    $("button#msds_sheet").removeClass("required btn-danger").hide();
                }
                else if (sds_waiver == "Y") {
                    $("button#sds_waiver").removeClass("required btn-danger").hide();
                    $("button#msds_sheet").addClass("required btn-danger").show();
                }
                else {
                    $("button#sds_waiver").removeClass("required btn-danger").hide();
                    $("button#msds_sheet").removeClass("required btn-danger").hide();
                }
        //          $("select[name='front_store_item[sds_waiver]']").addClass('required');
            } else {
                $("#sds_waiver").attr('required',false).closest("div.form-group").removeAttr("requiredIf").removeClass("required");
        //          $("select[name='front_store_item[sds_waiver]']").removeClass('required');
            }

            if (!$("#product_regulated_iata").hasClass("disabled")) {
                $("#product_regulated_iata").attr("disabled",false).parent("td").removeClass("readonly");
            }
            $("input[name='product_regulated_iata']").remove();
            $("#product_regulated_iata").trigger("change");
        } else {
            // Clear out the IATA flag, force them to select a value
            // Only if they haven't already chosen a new value
            if (!$("#product_regulated_iata").hasClass('changed')){
               $("#product_regulated_iata").val('').trigger('change');
            };

            $("#product_regulated_iata").val("Y").trigger("change");
            $("#product_regulated_iata").attr("disabled",true).parent("td").addClass("readonly");
            $("#product_regulated_iata").after('<input type="hidden" name="product_regulated_iata" value="Y">');
        }
    });

    $("#product_regulated_iata").change(function() {
        $("#sds_waiver").attr('required',false).closest("div.form-group").removeAttr("requiredIf").removeClass("required");
        $(this).addClass('changed');
        if ($(this).val() == "N") {
            sds_button_iata = false;
            if (sds_button_cfr){
                $("#sds_waiver").attr('required',true).closest("div.form-group").addClass("required");
                $("#sds_waiver").addClass("enforce_required").trigger('change');
                var sds_waiver = $("#sds_waiver").val();
                if (sds_waiver == "N") {
                    $("button#sds_waiver").addClass("required btn-danger").show();
                    $("button#msds_sheet").removeClass("required btn-danger").hide();
                }
                else if (sds_waiver == "Y") {
                    $("button#sds_waiver").removeClass("required btn-danger").hide();
                    $("button#msds_sheet").addClass("required btn-danger").show();
                }
                else {
                    $("button#sds_waiver").removeClass("required btn-danger").hide();
                    $("button#msds_sheet").removeClass("required btn-danger").hide();
                }
        //          $("select[name='front_store_item[sds_waiver]']").addClass('required');
            } else {
                $("#sds_waiver").attr('required',false).closest("div.form-group").removeAttr("requiredIf").removeClass("required");
        //          $("select[name='front_store_item[sds_waiver]']").removeClass('required');
            }
        } else {
            // Clear out the IATA flag, force them to select a value
            // Only if they haven't already chosen a new value
            if (!$("#product_regulated_cfr").hasClass('changed')){
               $("#product_regulated_cfr").val('').trigger('change');
            };
         }
    });

    $("#un_id_cfr").change(function() {
        $("#sds_waiver").attr('required',false).closest("div.form-group").removeAttr("requiredIf").removeClass("required");
        if ($(this).val() != abcsetup.item.un_id_cfr){
            sds_button_cfr = true;
            $("#sds_waiver").attr('required',true).closest("div.form-group").addClass("required");
            $("#sds_waiver").addClass("enforce_required").trigger('change');
            var sds_waiver = $("#sds_waiver").val();
            if (sds_waiver == "N") {
                $("button#sds_waiver").addClass("required btn-danger").show();
                $("button#msds_sheet").removeClass("required btn-danger").hide();
            }
            else if (sds_waiver == "Y") {
                $("button#sds_waiver").removeClass("required btn-danger").hide();
                $("button#msds_sheet").addClass("required btn-danger").show();
            }
            else {
                $("button#sds_waiver").removeClass("required btn-danger").hide();
                $("button#msds_sheet").removeClass("required btn-danger").hide();
            }
    //       $("select[name='front_store_item[sds_waiver]']").addClass('required');
        } else {
            sds_button_cfr = false;
            if (!sds_button_iata){
                $("#sds_waiver").attr('required',false).closest("div.form-group").removeAttr("requiredIf").removeClass("required");
        //          $("select[name='front_store_item[sds_waiver]']").removeClass('required');
            }
        }
    });
    $("#un_id_iata").change(function() {
        $("#sds_waiver").attr('required',false).closest("div.form-group").removeAttr("requiredIf").removeClass("required");
        if ($(this).val() != abcsetup.item.un_id_iata){
            sds_button_iata = true;
            $("#sds_waiver").attr('required',true).closest("div.form-group").addClass("required");
            $("#sds_waiver").addClass("enforce_required").trigger('change');
            var sds_waiver = $("#sds_waiver").val();
            if (sds_waiver == "N") {
                $("button#sds_waiver").addClass("required btn-danger").show();
                $("button#msds_sheet").removeClass("required btn-danger").hide();
            }
            else if (sds_waiver == "Y") {
                $("button#sds_waiver").removeClass("required btn-danger").hide();
                $("button#msds_sheet").addClass("required btn-danger").show();
            }
            else {
                $("button#sds_waiver").removeClass("required btn-danger").hide();
                $("button#msds_sheet").removeClass("required btn-danger").hide();
            }
    //       $("select[name='front_store_item[sds_waiver]']").addClass('required');
        } else {
            sds_button_iata = false;
            if (!sds_button_cfr){
                $("#sds_waiver").attr('required',false).closest("div.form-group").removeAttr("requiredIf").removeClass("required");
        //          $("select[name='front_store_item[sds_waiver]']").removeClass('required');
            }
        }
    });
    // sds_old_val = abcsetup.item.sds_waiver;
    $("#sds_waiver").change(function() {
        var sds_waiver = $(this).val();
        var enforce = false;
        if ($(this).hasClass('enforce_required')) {
            // The SDS sheet / waiver is required y another field change
            enforce = true;
        }
        if (sds_waiver == "N" && (sds_waiver != abcsetup.item.sds_waiver || enforce)) {
            $("button#sds_waiver").addClass("required btn-danger").show();
            $("button#msds_sheet").removeClass("required btn-danger").hide();
        }
        else if (sds_waiver == "Y" && (sds_waiver != abcsetup.item.sds_waiver || enforce)) {
            $("button#sds_waiver").removeClass("required btn-danger").hide();
            $("button#msds_sheet").addClass("required btn-danger").show();
        }
        else if (sds_waiver == abcsetup.item.sds_waiver) {
            $("button#sds_waiver").removeClass("required btn-danger").hide();
            $("button#msds_sheet").removeClass("required btn-danger").hide();
        }
        else {
            $("button#sds_waiver").removeClass("required btn-danger").hide();
            $("button#msds_sheet").removeClass("required btn-danger").hide();
        }

        // From code commented out below, line ~843
        if (abcsetup.userRole.class == 'asd_buyer') {
            $("button[id='sds_waiver']").removeClass("required");
            $("#msds_sheet").removeClass("required");
            $("#flat_product_bar_code_image").removeClass("required");
            // $("#case_label").removeClass("required");
        }
        else if (abcsetup.userRole.class == 'bluepoint_cm') {
            // $("#case_label").removeClass("required");
        }

    }).trigger('change');

    $("#pr_registration").change(function() {
        var pr_registration = $(this).val();
        if (pr_registration != abcsetup.item.pr_registration){
            if (pr_registration == "Y") {
                $("button#pr_registration_doc").addClass("required btn-danger").show();
            }
            else {
                $("button#pr_registration_doc").removeClass("required btn-danger").hide();
            }
        }
    });

    $("#trade_agreement").change(function() {
        var trade_agreement = $(this).val();
        if (trade_agreement != abcsetup.item.trade_agreement){
            if (trade_agreement == "Y") {
                $("button#hda_form").addClass("required btn-danger").show();
            }
            else {
                $("button#hda_form").removeClass("required btn-danger").hide();
            }
        }
        else {
            $("button#hda_form").removeClass("required btn-danger").hide();
        }
    });

    $("#temp_range").change(function() {
        var temp_range = $(this).val();
        if (temp_range != abcsetup.item.temp_range){
            if (temp_range != "") {
                $("button#hda_form").addClass("required btn-danger").show();
                $("button#flat_product_bar_code_image").addClass("required btn-danger").show();
            }
            else {
                $("button#hda_form").removeClass("required btn-danger").hide();
                $("button#flat_product_bar_code_image").removeClass("required btn-danger").hide();
            }
        }
        else {
            $("button#hda_form").removeClass("required btn-danger").hide();
            $("button#flat_product_bar_code_image").removeClass("required btn-danger").hide();
        }
    });

    $("#mfg_part_num").change(function() {
        var mfg_part_num = $(this).val();
        if (mfg_part_num != abcsetup.item.mfg_part_num){
            if (mfg_part_num != "") {
                $("button#spec_sheet").addClass("required btn-danger").show();
                $("button#flat_product_bar_code_image").addClass("required btn-danger").show();
            }
            else {
                $("button#spec_sheet").removeClass("required btn-danger").hide();
                $("button#flat_product_bar_code_image").removeClass("required btn-danger").hide();
            }
        }
        else {
            $("button#spec_sheet").removeClass("required btn-danger").hide();
            $("button#flat_product_bar_code_image").removeClass("required btn-danger").hide();
        }
    });

    $("#case_ean").change(function() {
        var case_ean = $(this).val();
        if (case_ean != abcsetup.item.case_ean){
            if (case_ean != "") {
                $("button#spec_sheet").addClass("required btn-danger").show();
                $("button#flat_product_bar_code_image").addClass("required btn-danger").show();
            }
            else {
                $("button#spec_sheet").removeClass("required btn-danger").hide();
                $("button#flat_product_bar_code_image").removeClass("required btn-danger").hide();
            }
        }
        else {
            $("button#spec_sheet").removeClass("required btn-danger").hide();
            $("button#flat_product_bar_code_image").removeClass("required btn-danger").hide();
        }
    });

    $("#inner_ean").change(function() {
        var inner_ean = $(this).val();
        if (inner_ean != abcsetup.item.inner_ean){
            if (inner_ean != "") {
                $("button#spec_sheet").addClass("required btn-danger").show();
                $("button#flat_product_bar_code_image").addClass("required btn-danger").show();
            }
            else {
                $("button#spec_sheet").removeClass("required btn-danger").hide();
                $("button#flat_product_bar_code_image").removeClass("required btn-danger").hide();
            }
        }
        else {
            $("button#spec_sheet").removeClass("required btn-danger").hide();
            $("button#flat_product_bar_code_image").removeClass("required btn-danger").hide();
        }
    });

    $("#listed_chemical").change(function() {
        var listed_chemical = $(this).val();
        if (listed_chemical != abcsetup.item.listed_chemical){
            if (listed_chemical == "Y") {
                $("button#hda_form").addClass("required btn-danger").show();
                $("button#flat_product_bar_code_image").addClass("required btn-danger").show();
                // $("button#sds_waiver").addClass("required btn-danger").show();
                $("#sds_waiver").attr('required',true).closest("div.form-group").addClass("required");
                $("#sds_waiver").addClass("enforce_required").trigger('change');
            }
            else {
                $("button#hda_form").removeClass("required btn-danger").hide();
                $("button#flat_product_bar_code_image").removeClass("required btn-danger").hide();
                $("button#sds_waiver").removeClass("required btn-danger").hide();
                $("#listed_chemical_ingredient").val('');
                $("#listed_chemical_ingredient_amount").val('');
                $("#listed_chemical_ingredient_amount_unit").val('');
                $("#listed_chemical_category").val('');
            }
        }
        else {
            $("button#hda_form").removeClass("required btn-danger").hide();
            $("button#flat_product_bar_code_image").removeClass("required btn-danger").hide();
            $("button#sds_waiver").removeClass("required btn-danger").hide();
        }
    });

    $("#aerosol_class").change(function() {
        var aerosol_class = $(this).val();
        if (aerosol_class != abcsetup.item.aerosol_class){
            if (aerosol_class == "Y") {
                $("button#hda_form").addClass("required btn-danger").show();
                $("button#flat_product_bar_code_image").addClass("required btn-danger").show();
                // $("button#sds_waiver").addClass("required btn-danger").show();
                $("#sds_waiver").attr('required',true).closest("div.form-group").addClass("required");
                $("#sds_waiver").addClass("enforce_required").trigger('change');
            }
            else {
                $("button#hda_form").removeClass("required btn-danger").hide();
                $("button#flat_product_bar_code_image").removeClass("required btn-danger").hide();
                $("button#sds_waiver").removeClass("required btn-danger").hide();
            }
        }
        else {
            $("button#hda_form").removeClass("required btn-danger").hide();
            $("button#flat_product_bar_code_image").removeClass("required btn-danger").hide();
            $("button#sds_waiver").removeClass("required btn-danger").hide();
        }
    });

    $("#alcohol").change(function() {
        var alcohol = $(this).val();
        if (alcohol != abcsetup.item.alcohol){
            if (alcohol == "Y") {
                $("button#hda_form").addClass("required btn-danger").show();
                $("button#flat_product_bar_code_image").addClass("required btn-danger").show();
                // $("button#sds_waiver").addClass("required btn-danger").show();
                $("#sds_waiver").attr('required',true).closest("div.form-group").addClass("required");
                $("#sds_waiver").addClass("enforce_required").trigger('change');
            }
            else {
                $("button#hda_form").removeClass("required btn-danger").hide();
                $("button#flat_product_bar_code_image").removeClass("required btn-danger").hide();
                $("button#sds_waiver").removeClass("required btn-danger").hide();
            }
        }
        else {
            $("button#hda_form").removeClass("required btn-danger").hide();
            $("button#flat_product_bar_code_image").removeClass("required btn-danger").hide();
            $("button#sds_waiver").removeClass("required btn-danger").hide();
        }
    });

    $("#flammable").change(function() {
        var flammable = $(this).val();
        if (flammable != abcsetup.item.flammable){
            if (flammable == "Y") {
                $("button#hda_form").addClass("required btn-danger").show();
                $("button#flat_product_bar_code_image").addClass("required btn-danger").show();
                // $("button#sds_waiver").addClass("required btn-danger").show();
                $("#sds_waiver").attr('required',true).closest("div.form-group").addClass("required");
                $("#sds_waiver").addClass("enforce_required").trigger('change');
            }
            else {
                $("button#hda_form").removeClass("required btn-danger").hide();
                $("button#flat_product_bar_code_image").removeClass("required btn-danger").hide();
                $("button#sds_waiver").removeClass("required btn-danger").hide();
            }
        }
        else {
            $("button#hda_form").removeClass("required btn-danger").hide();
            $("button#flat_product_bar_code_image").removeClass("required btn-danger").hide();
            $("button#sds_waiver").removeClass("required btn-danger").hide();
        }
    });


    // shipping_method logic:
    // the onchange event of shipping_method affects inners, wholesale_unit, quantity_measure
    // and #tab_inner-information
    var shipping_method_select = $("#shipping_method");
    var pcode_uom_select = $("#pcode_uom");
    var pcode_uom_val = $("#pcode_uom").val();
    var inners_select = $("#inners");
    var wholesale_unit_select = $("#wholesale_unit");
    var quantity_measure_select = $("#quantity_measure");
    var po_id_select = $("#po_id");
    var pcode_identifier_select = $("#pcode_identifier");
    var inners_init = inners_select.val();
    var shipping_method = shipping_method_select.val();
    var quantity_measure = quantity_measure_select.val();
    var po_id = po_id_select.val();
    var quantity_measure_select_title = {
        CS: "Click drop down arrow and select the Order Quantity Measure:\n- Cases\n- Dozens\n- Inners (PK)\n- Eaches",
        DZ: "Click drop down arrow and select the Order Quantity Measure:\n- Dozens\n- Inners (PK)\n- Eaches",
        PK: "Click drop down arrow and select the Order Quantity Measure:\n- Inners (PK)\n- Eaches",
        EA: "Click drop down arrow and select the Order Quantity Measure:\n- Eaches",
    };
    var quantity_measure_options = {
        // key = shipping_method
        CS: {
            "": "-select-",
            "CS": "Cases",
            "DZ": "Dozens",
            "PK": "Inners (PK)",
            "EA": "Eaches"
        },
        DZ: {
            "": "-select-",
            "DZ": "Dozens",
            "PK": "Inners (PK)",
            "EA": "Eaches"
        },
        PK: {
            "": "-select-",
            "PK": "Inners (PK)",
            "EA": "Eaches"
        },
        EA:{
            "": "-select-",
            "EA": "Eaches",
        },
        DL: {
            "": "-select-",
            "DL": "DL",
        },
    };
    var wholesale_unit_options = {
        // key = shipping_method
        CS: {
            "": "-select-",
            "CS": "Cases",
            "PK": "Inners (PK)",
            "EA": "Eaches"
        },
        DZ: {
            "": "-select-",
            "EA": "Eaches"
        },
        PK: {
            "": "-select-",
            "PK": "Inners (PK)",
            "EA": "Eaches"
        },
        EA:{
            "": "-select-",
            "EA": "Eaches",
        },
        DL: {
            "": "-select-",
            "DL": "DL",
        },
    };

    var uom_codes = {
        "EAN": "EAN",
        "GTIN": "GTIN",
        "HIBCC": "HIBC",
        "HRI": "HRI",
        "NDC": "NDC",
        "UPC": "UPC",
        "VC": "VC",
        "VB": "VB",
    };

    var po_id_options = {
        CS: {"": "-select-"},
        DZ: {"": "-select-"},
        PK: {"": "-select-"},
        EA: {"": "-select-"},
        DL: {"": "-select-"},
    };

    $.each(['CS','DZ','PK','EA','DL'], function(uom_idx,uom_val) {
        $.each(uom_codes, function(code_idx,code_val) {
            var t = uom_val+" "+code_idx;
            if (uom_val == "CS" || uom_val == "DZ" || uom_val == "PK" || uom_val == "EA") {
                po_id_options["CS"][t] = uom_val+" "+code_val;
            }
            if (uom_val == "DZ" || uom_val == "PK" || uom_val == "EA") {
                po_id_options["DZ"][t] = uom_val+" "+code_val;
            }
            if (uom_val == "PK" || uom_val == "EA") {
                po_id_options["PK"][t] = uom_val+" "+code_val;
            }
            if (uom_val == "EA") {
                po_id_options["EA"][t] = uom_val+" "+code_val;
            }
            if (uom_val == "DL") {
                if(code_val != "VC" && code_val != "VB") {
                    po_id_options["DL"][t] = uom_val+" "+code_val;
                }
            }
        });
    });

    var pcode_uom_options ;

    if($("#type").val() == 'display') {
        pcode_uom_options = { "": "-select-", DL: "Display" };
    } else {
        pcode_uom_options = {"": "-select-", CS: "Cases", DZ: "Dozens", PK: "Inners (PK)", EA: "Eaches"};
    }

    if (abcsetup.item != undefined) {
        if (abcsetup.item.shipping_method != undefined) {
            if (abcsetup.item.shipping_method !== 'DZ') {
                delete pcode_uom_options.DZ;
            }
        }
        if (abcsetup.item.shipping_method != undefined) {
            if (abcsetup.item.inners == "N") {
                delete pcode_uom_options.PK;
            }
        }
    }

    html_select_options_replace({
        select: pcode_uom_select,
        options: pcode_uom_options,
        selected: pcode_uom_val,
    });

    var p_code_options = {
        CS: {"": "-select-"},
        DZ: {"": "-select-"},
        PK: {"": "-select-"},
        EA: {"": "-select-"},
        DL: {"": "-select-"},
    };

    var uom_code_convert = {
        'CS': 'case',
        'DZ': 'dozens',
        'PK': 'pack',
        'EA': 'item',
        'DL': 'display'
    }

    var pcode_identifier_codes = ["EAN","GTIN","HIBCC","HRI","NDC10","UPC","VC","VB"];

    $.each(['CS','DZ','PK','EA','DL'], function(uom_idx,uom_val) {
        $.each(pcode_identifier_codes, function(code_idx,code_val) {
           var t = uom_val+" "+code_val;
           if(code_val !== 'VC' && code_val !== "VB") {
            p_code_options[uom_val][t] = t ;
            } else {
                var field_name = uom_code_convert[uom_val]+"_"+code_val.toLowerCase();
                if (code_val == 'VC') {
                    var vc_field = $("#"+field_name);
                    if(!vc_field.prop('disabled') && !vc_field.is(":hidden") && vc_field.length) {
                        p_code_options[uom_val][t] = t ;
                    }
                }
                if (code_val == 'VB') {
                    var vb_field = $("#"+field_name);
                    if(!vb_field.prop('disabled') && !vb_field.is(":hidden") && vb_field.length) {
                        p_code_options[uom_val][t] = t ;
                    }
                }
            }
        });
    });

    $.each(['CS','DZ','PK','EA','DL'], function(uom_idx,uom_val) {
        // append MP to each list
        po_id_options[uom_val]["MP"] = "Mfg Part #";
    });

    /*$(".article_identifier").change(function() {
        var format_code = $(this).closest("tr").find(".format_code");
        format_code.closest("span").find(".input_required_indicator").remove();
        if($(this).val().length && format_code.is(":visible")) {
           $('<span class="input_required_indicator">*</span>').insertAfter(format_code);
        }
    });

    $(".article_identifier").each(function(){
        var format_code = $(this).closest("tr").find(".format_code");
        format_code.closest("span").find(".input_required_indicator").remove();
        if($(this).val().length && format_code.is(":visible")) {
           $('<span class="input_required_indicator">*</span>').insertAfter(format_code);
        }
    });*/

    po_id_select.change(function() {
        var po_id_val = po_id_select.val();
        if (po_id_val == "" || po_id_val === null) {
            return;
        }
        var css_classes = ["item_product_code","case_product_code","inner_product_code","dozens_product_code"];
        for (var idx in css_classes) {
            $("."+css_classes[idx]).attr('required', false).removeClass("invalid");
            $("."+css_classes[idx]).closest("div.form-group").removeAttr("requiredIf").removeClass("required");
        }
        switch (po_id_val.substr(0,2)) {
           case "CS":
            var case_identifier;
            if (po_id_val.substr(3).toLowerCase() != 'ndc') {
                case_identifier = $("#case_"+po_id_val.substr(3).toLowerCase());
            }
            else {
                case_identifier = $("#case_"+po_id_val.substr(3).toLowerCase()+"10_format");
            }
            case_identifier.attr('required', true);
            case_identifier.closest("div.form-group").addClass("required");
            break;
           case "DZ":
            var dozens_identifier;
            if (po_id_val.substr(3).toLowerCase() != 'ndc') {
                dozens_identifier = $("#dozens_"+po_id_val.substr(3).toLowerCase());
            }
            else {
                dozens_identifier = $("#dozens_"+po_id_val.substr(3).toLowerCase()+"10_format");
            }
            dozens_identifier.attr('required', true);
            dozens_identifier.closest("div.form-group").addClass("required");
            break;
           case "PK":
            var inner_identifier;
            if (po_id_val.substr(3).toLowerCase() != 'ndc') {
                inner_identifier = $("#inner_"+po_id_val.substr(3).toLowerCase());
            }
            else {
                inner_identifier = $("#inner_"+po_id_val.substr(3).toLowerCase()+"10_format");
            }
            inner_identifier.attr('required', true);
            inner_identifier.closest("div.form-group").addClass("required");
            break;
        }
        if (po_id_val != "MP") {
           // at least one item_product_code must be provided for any value of po_Id except MP - see ticket:703
           console.log('add item identifier required back')
            $(".item_product_code").attr('required', true);
            $(".item_product_code").closest("div.form-group").addClass("required");
            $(".item_article_identifier").trigger("change");
        }
    }).trigger("change");

    inners_select.change(function(){
        var inners_val = $(this).val();
        var wholesale_unit = '';
        var wsu_options = Object.assign({},wholesale_unit_options[shipping_method]);
        if (wholesale_unit_select.length) {
            wholesale_unit = wholesale_unit_select.val();
        }
        if (inners_val == 'N') {
        delete wsu_options.PK;
            if (wholesale_unit == 'PK'){
                wholesale_unit = '';
            }
            if (shipping_method != 'PK'){
                shipping_method_select.find("option[value='PK']").remove();
             }
        }
        html_select_options_replace({
            select: wholesale_unit_select,
            options: wsu_options,
            selected: wholesale_unit,
        });
    });

    shipping_method_select.change(function() {
        var shipping_method = $(this).val();
        var wholesale_unit = '';
        var case_pack_quantity = $("#case_pack_quantity").val();
        var inner_pack_quantity = $("#inner_pack_quantity").val();
        var qtyInners = $("#quantity_inners").val();
        if (wholesale_unit_select.length) {
           wholesale_unit = wholesale_unit_select.val();
        }
        var quantity_measure = quantity_measure_select.val();
        var po_id = po_id_select.val();
        if (shipping_method) {
           // update wholesale_unit_select
           if (wholesale_unit_select.length) {
              html_select_options_replace({
                 select: wholesale_unit_select,
                 options: wholesale_unit_options[shipping_method],
                 selected: wholesale_unit,
              });
           }
           // update quantity_measure_select
           if (quantity_measure_select.length) {
              html_select_options_replace({
                 select: quantity_measure_select,
                 options: quantity_measure_options[shipping_method],
                 selected: quantity_measure,
              });
              quantity_measure_select.attr("title",quantity_measure_select_title[shipping_method]);
           }
           // update po_id_select
           if (po_id_select.length) {
              html_select_options_replace({
                 select: po_id_select,
                 options: po_id_options[shipping_method],
                 selected: po_id,
              });
           }
        }
        switch (shipping_method) {
            case "PK":
                // set inners_select and expose inners tab
                inners_select.val("Y").change().attr("disabled",true).parent("td").addClass("readonly");;
                inners_select.after('<input type="hidden" name="inners" id="inners" value="Y">');
                tabs_inner_information.closest('li').show();
                break;
            case "CS":
            case "DZ":
            case "EA":
                // NOTE: do NOT alter the value of inners_select or visibility of #tab_inner-information
                //inners = inners_select.val();
                // inners_select.attr("disabled",false).parent("td").removeClass("readonly");
                $("input[name='inners']").remove(); // remove hidden input inserted above
                //inners_select.val(inners).change();
                //$("[href='#tab_inner-information']").closest('li').hide();
                var no_inner_data = true;
                $("#tab_inner-information").find("input").each(function() {
                    if ($(this).val() != "") {
                        //console_log("eval(no_inner_data)->"+$(this).attr("name")+"->"+$(this).val());
                        no_inner_data = false;
                        return false;
                    }
                });
                if (no_inner_data) {
                    // if inners_init was set, then explicitly set it N, otherwise blank
                    if (inners_init) {
                        inners_select.val("N").change();
                    }
                    else {
                        inners_select.val("").change();
                    }
                }
                break;
        }
    });

    pcode_uom_select.change(function() {
        var item_iden = $(this).val();
        if(item_iden && p_code_options) {
            html_select_options_replace({
                select: pcode_identifier_select,
                options: p_code_options[item_iden],
            });
        }
    });

    pcode_identifier_select.change(function() {
        $.each(['CS','DZ','PK','EA','DL'], function(uom_idx,uom_val) {
            $.each(pcode_identifier_codes,function(code_idx,code_val) {
                var field_name = uom_code_convert[uom_val]+"_"+code_val.toLowerCase();
                if(!$("#"+field_name).closest("td").hasClass("required")) {
                    $("#"+field_name).parent().find(".pcode_identifier").remove();
                }
            });
        });

        if($(this).val()) {
            pcode = $(this).val();
            var uom_val = uom_code_convert[pcode.split(' ')[0]];
            var code_val =  pcode.split(' ')[1].toLowerCase();
            var field_name = uom_val + '_'+ code_val;
            var iden_field = $("#"+field_name);
            if(pcode) {
                iden_field.attr('required', false).removeClass("invalid");
                iden_field.closest("div.form-group").removeAttr("requiredIf").removeClass("required");
                $('<span class="input_required_indicator pcode_identifier">*</span>').insertAfter("#"+field_name);
            }
        }
    });

    if (abcsetup.item != undefined) {
        if (abcsetup.item.pcode_uom != undefined) {
            pcode_uom_select.trigger('change');
            pcode_identifier_select.val(abcsetup.item.pcode_identifier);
            pcode_identifier_select.trigger('change');
        }
    }

    if (!shipping_method_select.is(':disabled')) {
        // only trigger change event if shipping_method_select is not disabled
        shipping_method_select.trigger("change");
    }

    // $("#sds_waiver").change(function() {
    //     var sds_waiver = $(this).val();
    //     if (sds_waiver == "N") {
    //         $("button[id='sds_waiver']").addClass("btn-required required").show();
    //         $("#msds_sheet").removeClass("btn-required required").hide();
    //     }
    //     else if (sds_waiver == "Y") {
    //         $("button[id='sds_waiver']").removeClass("btn-required required").hide();
    //         $("#msds_sheet").addClass("btn-required required").show();
    //     }
    //     else {
    //         $("button[id='sds_waiver']").removeClass("btn-required required").hide();
    //         $("#msds_sheet").removeClass("btn-required required").hide();
    //     }

    //     if (abcsetup.userRole.class == 'asd_buyer') {
    //         $("button[id='sds_waiver']").removeClass("required");
    //         $("#msds_sheet").removeClass("required");
    //         $("#flat_product_bar_code_image").removeClass("required");
    //         // $("#case_label").removeClass("required");
    //     }
    //     else if (abcsetup.userRole.class == 'bluepoint_cm') {
    //         // $("#case_label").removeClass("required");
    //     }
    // });
    $(function() {
        if ($("#sds_waiver").length) {
            $("#sds_waiver").trigger("change");
        }
        else {
            $("button[id='sds_waiver']").removeClass("btn-required required").hide();
            $("#msds_sheet").removeClass("btn-required required").hide();
        }

        if (abcsetup.userRole.class == 'bluepoint_cm') {
            $("#flat_product_bar_code_image").removeClass("required");
        }

        if (abcsetup.userRole.class != 'bluepoint_cm') {
            $("#sap_pricing_letter").removeClass("required").hide();
            $("#ahp_pricing_letter").removeClass("required").hide();
            $("#mwi_pricing_letter").removeClass("required").hide();
        }
    });

    /*
    * CFR and IATA hazmat
    */
    var hazmat_fields = {
        cfr: [
            "product_regulated",
            "un_id",
            "hazard_class",
            "pack_group",
            "shipping_name_1",
            "label_code",
            "qty_limit_par",
            "qty_limit_cao",
            "vessel_stowage_location",
            "vessel_stowage_other",
        ],
        iata: [
            "product_regulated",
            "un_id",
            "shipping_name",
            "descr",
            "pack_group",
        ],
    };
    var hazmat_types = ['cfr','iata'];
    var hazmat_config = {
        change_field: function(args) {
            // args: hazmat_type, field, data_obj
            console.log("hazmat_config.change_field: args->"+JSON.stringify(args,{},4));
            hazmat_config[args.hazmat_type][args.field+"_select"].obj.empty();
            var list_length = Object.keys(args.data_obj).length;
            if (list_length > 1) {
                hazmat_config[args.hazmat_type][args.field+"_select"].obj.append($("<option></option>").attr("value","").text("-select-"));
            }
            Object.keys(args.data_obj).forEach(function(key) {
                hazmat_config[args.hazmat_type][args.field+"_select"].obj.append($("<option></option>").attr("value",key).text(key));
            });
            if (list_length == 1) {
                hazmat_config[args.hazmat_type][args.field+"_select"].obj.trigger("change");
            }
            else {
                if (hazmat_config[args.hazmat_type][args.field+"_select"].obj.find("option[value='"+hazmat_config[args.hazmat_type][args.field+"_select"].val+"']").length) {
                    hazmat_config[args.hazmat_type][args.field+"_select"].obj.val(hazmat_config[args.hazmat_type][args.field+"_select"].val);
                    hazmat_config[args.hazmat_type][args.field+"_select"].obj.trigger("change");
                }
            }
        }
    };

    hazmat_types.forEach(function(hazmat_type) {
        hazmat_config[hazmat_type] = {};
        // field objects
        hazmat_fields[hazmat_type].forEach(function(hazmat_field) {
            hazmat_config[hazmat_type][hazmat_field+"_select"] = {};
            hazmat_config[hazmat_type][hazmat_field+"_select"]["obj"] = $("#"+hazmat_field+"_"+hazmat_type);
            hazmat_config[hazmat_type][hazmat_field+"_select"]["val"] = "_undef_";
            if (abcsetup.item != undefined) {
                if (abcsetup.item[hazmat_field+"_"+hazmat_type] != undefined) {
                    hazmat_config[hazmat_type][hazmat_field+"_select"]["val"] = abcsetup.item[hazmat_field+"_"+hazmat_type]
                }
            }
        });
    });

    // add event handlers
    var abc_hazmat_obj = {};
    var selected_hazmat_fields = {};
    hazmat_types.forEach(function(hazmat_type) {
        selected_hazmat_fields[hazmat_type] = {};
        console.log('hazmat event handlers');
        if (!hazmat_config[hazmat_type].un_id_select.obj.is(":disabled")) {
            if (hazmat_type == "cfr") {
                console.log('hazmat event handlers: cfr', hazmat_config[hazmat_type].un_id_select.obj);
                // un_id_select -> hazard_class_select
                hazmat_config[hazmat_type].un_id_select.obj.change(function() {
                    console.log('hazmat event handlers: cfr: un_id change');
                    selected_hazmat_fields[hazmat_type]["un_id"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    $("#hazmat_id_"+hazmat_type).val("");
                    hazmat_fields[hazmat_type].forEach(function(hazmat_field) {
                        if (hazmat_field != "un_id" && hazmat_field != "product_regulated") {
                            hazmat_config[hazmat_type][hazmat_field+"_select"].obj.empty().append($("<option></option>").attr("value","").text("-select-"));
                        }
                    });
                    $.ajax({
                        type: "POST",
                        url: "/abc_item/hazmat_cfr_search",
                        cache: false,
                        dataType: 'json',
                        data: {un_id: un_id},
                        success: function(result) {
                            console.log("item/hazmat_cfr_search[hazard_class]: result->"+JSON.stringify(result,{},4));
                            if (!$.isEmptyObject(result)) {
                                abc_hazmat_obj[hazmat_type] = result;
                                hazmat_config.change_field({
                                    hazmat_type: hazmat_type,
                                    field: "hazard_class",
                                    data_obj: abc_hazmat_obj[hazmat_type][un_id]["hazard_class"]
                                });
                            }
                        }
                    });
                });
                // hazard_class_select -> pack_group_select
                hazmat_config[hazmat_type].hazard_class_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["hazard_class"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var hazard_class = selected_hazmat_fields[hazmat_type]["hazard_class"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    hazmat_config.change_field({
                        hazmat_type: hazmat_type,
                        field: "pack_group",
                        data_obj: abc_hazmat_obj[hazmat_type][un_id]["hazard_class"][hazard_class]['pack_group']
                    });
                });
                // pack_group_select -> shipping_name_1_select
                hazmat_config[hazmat_type].pack_group_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["pack_group"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var hazard_class = selected_hazmat_fields[hazmat_type]["hazard_class"];
                    var pack_group = selected_hazmat_fields[hazmat_type]["pack_group"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    hazmat_config.change_field({
                        hazmat_type: hazmat_type,
                        field: "shipping_name_1",
                        data_obj: abc_hazmat_obj[hazmat_type][un_id]["hazard_class"][hazard_class]['pack_group'][pack_group]["shipping_name_1"]
                    });
                });
                // shipping_name_1_select -> label_code_select
                hazmat_config[hazmat_type].shipping_name_1_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["shipping_name_1"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var hazard_class = selected_hazmat_fields[hazmat_type]["hazard_class"];
                    var pack_group = selected_hazmat_fields[hazmat_type]["pack_group"];
                    var shipping_name_1 = selected_hazmat_fields[hazmat_type]["shipping_name_1"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    hazmat_config.change_field({
                        hazmat_type: hazmat_type,
                        field: "label_code",
                        data_obj: abc_hazmat_obj[hazmat_type][un_id]["hazard_class"][hazard_class]['pack_group'][pack_group]["shipping_name_1"][shipping_name_1]["label_code"]
                    });
                });
                // label_code_select -> qty_limit_par_select
                hazmat_config[hazmat_type].label_code_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["label_code"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var hazard_class = selected_hazmat_fields[hazmat_type]["hazard_class"];
                    var pack_group = selected_hazmat_fields[hazmat_type]["pack_group"];
                    var shipping_name_1 = selected_hazmat_fields[hazmat_type]["shipping_name_1"];
                    var label_code = selected_hazmat_fields[hazmat_type]["label_code"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    hazmat_config.change_field({
                        hazmat_type: hazmat_type,
                        field: "qty_limit_par",
                        data_obj: abc_hazmat_obj[hazmat_type][un_id]["hazard_class"][hazard_class]['pack_group'][pack_group]["shipping_name_1"][shipping_name_1]["label_code"][label_code]["qty_limit_par"]
                    });
                });
                // qty_limit_par_select -> qty_limit_cao_select
                hazmat_config[hazmat_type].qty_limit_par_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["qty_limit_par"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var hazard_class = selected_hazmat_fields[hazmat_type]["hazard_class"];
                    var pack_group = selected_hazmat_fields[hazmat_type]["pack_group"];
                    var shipping_name_1 = selected_hazmat_fields[hazmat_type]["shipping_name_1"];
                    var label_code = selected_hazmat_fields[hazmat_type]["label_code"];
                    var qty_limit_par = selected_hazmat_fields[hazmat_type]["qty_limit_par"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    hazmat_config.change_field({
                        hazmat_type: hazmat_type,
                        field: "qty_limit_cao",
                        data_obj: abc_hazmat_obj[hazmat_type][un_id]["hazard_class"][hazard_class]['pack_group'][pack_group]["shipping_name_1"][shipping_name_1]["label_code"][label_code]["qty_limit_par"][qty_limit_par]["qty_limit_cao"]
                    });
                });
                // qty_limit_cao_select -> vessel_stowage_location_select
                hazmat_config[hazmat_type].qty_limit_cao_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["qty_limit_cao"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var hazard_class = selected_hazmat_fields[hazmat_type]["hazard_class"];
                    var pack_group = selected_hazmat_fields[hazmat_type]["pack_group"];
                    var shipping_name_1 = selected_hazmat_fields[hazmat_type]["shipping_name_1"];
                    var label_code = selected_hazmat_fields[hazmat_type]["label_code"];
                    var qty_limit_par = selected_hazmat_fields[hazmat_type]["qty_limit_par"];
                    var qty_limit_cao = selected_hazmat_fields[hazmat_type]["qty_limit_cao"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    hazmat_config.change_field({
                        hazmat_type: hazmat_type,
                        field: "vessel_stowage_location",
                        data_obj: abc_hazmat_obj[hazmat_type][un_id]["hazard_class"][hazard_class]['pack_group'][pack_group]["shipping_name_1"][shipping_name_1]["label_code"][label_code]["qty_limit_par"][qty_limit_par]["qty_limit_cao"][qty_limit_cao]["vessel_stowage_location"]
                    });
                });
                // vessel_stowage_location_select -> vessel_stowage_other_select
                hazmat_config[hazmat_type].vessel_stowage_location_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["vessel_stowage_location"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var hazard_class = selected_hazmat_fields[hazmat_type]["hazard_class"];
                    var pack_group = selected_hazmat_fields[hazmat_type]["pack_group"];
                    var shipping_name_1 = selected_hazmat_fields[hazmat_type]["shipping_name_1"];
                    var label_code = selected_hazmat_fields[hazmat_type]["label_code"];
                    var qty_limit_par = selected_hazmat_fields[hazmat_type]["qty_limit_par"];
                    var qty_limit_cao = selected_hazmat_fields[hazmat_type]["qty_limit_cao"];
                    var vessel_stowage_location = selected_hazmat_fields[hazmat_type]["vessel_stowage_location"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    hazmat_config.change_field({
                        hazmat_type: hazmat_type,
                        field: "vessel_stowage_other",
                        data_obj: abc_hazmat_obj[hazmat_type][un_id]["hazard_class"][hazard_class]['pack_group'][pack_group]["shipping_name_1"][shipping_name_1]["label_code"][label_code]["qty_limit_par"][qty_limit_par]["qty_limit_cao"][qty_limit_cao]["vessel_stowage_location"][vessel_stowage_location]["vessel_stowage_other"]
                    });
                });
                // vessel_stowage_other_select
                hazmat_config[hazmat_type].vessel_stowage_other_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["vessel_stowage_other"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var hazard_class = selected_hazmat_fields[hazmat_type]["hazard_class"];
                    var pack_group = selected_hazmat_fields[hazmat_type]["pack_group"];
                    var shipping_name_1 = selected_hazmat_fields[hazmat_type]["shipping_name_1"];
                    var label_code = selected_hazmat_fields[hazmat_type]["label_code"];
                    var qty_limit_par = selected_hazmat_fields[hazmat_type]["qty_limit_par"];
                    var qty_limit_cao = selected_hazmat_fields[hazmat_type]["qty_limit_cao"];
                    var vessel_stowage_location = selected_hazmat_fields[hazmat_type]["vessel_stowage_location"];
                    var vessel_stowage_other = selected_hazmat_fields[hazmat_type]["vessel_stowage_other"];
                    var hazmat_id = abc_hazmat_obj[hazmat_type][un_id]["hazard_class"][hazard_class]['pack_group'][pack_group]["shipping_name_1"][shipping_name_1]["label_code"][label_code]["qty_limit_par"][qty_limit_par]["qty_limit_cao"][qty_limit_cao]["vessel_stowage_location"][vessel_stowage_location]["vessel_stowage_other"][vessel_stowage_other]["hazmat_id"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    console.log("hazmat_id->"+hazmat_id);
                    $("#hazmat_id_"+hazmat_type).val(hazmat_id);
                });
                if (hazmat_config[hazmat_type].product_regulated_select.obj.val() == "Y") {
                    hazmat_config[hazmat_type].un_id_select.obj.trigger("change");
                }
            }
            else if (hazmat_type == "iata") {
                // un_id_select -> shipping_name_select
                hazmat_config[hazmat_type].un_id_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["un_id"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    $("#hazmat_id_"+hazmat_type).val("");
                    hazmat_fields[hazmat_type].forEach(function(hazmat_field) {
                        if (hazmat_field != "un_id" && hazmat_field != "product_regulated") {
                            hazmat_config[hazmat_type][hazmat_field+"_select"].obj.empty().append($("<option></option>").attr("value","").text("-select-"));
                        }
                    });
                    $.ajax({
                        type: "POST",
                        url: "/abc_item/hazmat_iata_search",
                        cache: false,
                        dataType: 'json',
                        data: {un_id: un_id},
                        success: function(result) {
                            console.log("item/hazmat_iata_search[shipping_name]: result->"+JSON.stringify(result,{},4));
                            if (!$.isEmptyObject(result)) {
                                abc_hazmat_obj[hazmat_type] = result;
                                hazmat_config.change_field({
                                    hazmat_type: hazmat_type,
                                    field: "shipping_name",
                                    data_obj: abc_hazmat_obj[hazmat_type][un_id]["shipping_name"]
                                });
                            }
                        }
                    });
                });
                // shipping_name_select -> descr_select
                hazmat_config[hazmat_type].shipping_name_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["shipping_name"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var shipping_name = selected_hazmat_fields[hazmat_type]["shipping_name"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    hazmat_config.change_field({
                        hazmat_type: hazmat_type,
                        field: "descr",
                        data_obj: abc_hazmat_obj[hazmat_type][un_id]["shipping_name"][shipping_name]['descr']
                    });
                });
                // descr_select -> pack_group_select
                hazmat_config[hazmat_type].descr_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["descr"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var shipping_name = selected_hazmat_fields[hazmat_type]["shipping_name"];
                    var descr = selected_hazmat_fields[hazmat_type]["descr"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    hazmat_config.change_field({
                        hazmat_type: hazmat_type,
                        field: "pack_group",
                        data_obj: abc_hazmat_obj[hazmat_type][un_id]["shipping_name"][shipping_name]['descr'][descr]["pack_group"]
                    });
                });
                // pack_group_select
                hazmat_config[hazmat_type].pack_group_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["pack_group"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var shipping_name = selected_hazmat_fields[hazmat_type]["shipping_name"];
                    var descr = selected_hazmat_fields[hazmat_type]["descr"];
                    var pack_group = selected_hazmat_fields[hazmat_type]["pack_group"];
                    var hazmat_id = abc_hazmat_obj[hazmat_type][un_id]["shipping_name"][shipping_name]['descr'][descr]["pack_group"][pack_group]["hazmat_id"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    console.log("hazmat_id->"+hazmat_id);
                    $("#hazmat_id_"+hazmat_type).val(hazmat_id);
                });
                if (hazmat_config[hazmat_type].product_regulated_select.obj.val() == "Y") {
                    hazmat_config[hazmat_type].un_id_select.obj.trigger("change");
                }
            }
        }
    });
});

function html_select_options_replace(args) {
    // args. select, options, selected
    if (!args.select) return;
    var selected = args.selected || "";
    args.select.children('option').remove()
    for(var val in args.options) {
        var option = $('<option/>',{value:val, text:args.options[val]});
        if (val && selected == val) {
            option.attr('selected',true);
        }
        option.appendTo(args.select);
    }
}
